/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
import { styleMap as l } from "lit/directives/style-map.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/chart/chart-legend.css.js
var u = r(":host{color:var(--color-fg-muted,currentColor);font-family:var(--font-sans);font-size:.6875rem;display:block}ul{flex-wrap:wrap;justify-content:center;gap:.25em .75em;margin:0;padding:0;list-style:none;display:flex}li{cursor:default;transition:opacity var(--duration-normal,.2s) ease;align-items:center;gap:.35em;display:flex}li:focus-visible{outline:var(--focus-ring,2px solid currentColor);outline-offset:2px;border-radius:var(--border-radius,.25em)}li[data-dimmed]{opacity:.35}[part=swatch]{border-radius:50%;block-size:.5rem;inline-size:.5rem}[part=value]{color:var(--color-fg,currentColor);font-variant-numeric:tabular-nums;font-weight:600}"), d = class extends e(i) {
	constructor(...e) {
		super(...e), this.items = [], this.styles = u, this._hovered = null, this._focused = null;
	}
	_emit() {
		this.dispatchEvent(new CustomEvent("chart-legend-highlight", {
			detail: { label: this._hovered ?? this._focused },
			bubbles: !0,
			composed: !0
		}));
	}
	_hover(e, t) {
		e.pointerType !== "touch" && (this._hovered = t, this._emit());
	}
	_focus(e) {
		this._focused = e, this._emit();
	}
	render() {
		return a`<ul role="list">
            ${this.items.map(({ label: e, color: t, value: n }) => a`<li
                        part="item"
                        ?data-dimmed=${!!this.highlight && this.highlight !== e}
                        tabindex="0"
                        @pointerenter=${(t) => this._hover(t, e)}
                        @pointerleave=${(e) => this._hover(e, null)}
                        @focus=${() => this._focus(e)}
                        @blur=${() => this._focus(null)}
                    >
                        <span part="swatch" style=${l({ background: t })}></span>${e}${n ? a`<span part="value">${n}</span>` : o}
                    </li>`)}
        </ul>`;
	}
};
n([c({ attribute: !1 }), t("design:type", Array)], d.prototype, "items", void 0), n([c(), t("design:type", String)], d.prototype, "highlight", void 0), d = n([s("ptc-ui-chart-legend")], d);
var f = d;
//#endregion
export { f as n, d as t };

//# sourceMappingURL=chart-legend-Bc1ePbVE.js.map